import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertCompanyGroup } from "./learningAPI";
import swal from 'sweetalert';
export interface InsertCompanyGroupState {
  insertCompanyGroup: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InsertCompanyGroupState = {
    insertCompanyGroup: [],
  status: "idle",
};

export const GetInsertCompanyGroup = createAsyncThunk(
  "InsertCompanyGroup/fetchInsertCompanyGroup",
  async (data:any) => {
    const response = await fetchInsertCompanyGroup(data);
    return response;
  }
);

export const InsertCompanyGroupSlice = createSlice({
  name: "InsertCompanyGroup",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInsertCompanyGroup.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInsertCompanyGroup.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetInsertCompanyGroup.fulfilled, (state, action) => {
        state.status = "idle";
        state.insertCompanyGroup = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = InsertCompanyGroupSlice.actions;

export const selectInsertCompanyGroup = (state: RootState) => {
  return state.InsertCompanyGroup.insertCompanyGroup;
};

export default InsertCompanyGroupSlice.reducer;
